if (
  typeof Array !== undefined
  && Array.prototype
  && !Array.prototype.last
) {
  Object.defineProperty(Array.prototype, 'last', {
    enumerable: false,
    configurable: true,
    get() {
      return this[this.length - 1];
    },
    set(value) {
      this[this.length - 1] = value;
    },
  });
}